import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories-report',
  templateUrl: './categories-report.component.html',
  styleUrls: ['./categories-report.component.css']
})
export class CategoriesReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
